"use client";

import { useEffect, useState } from "react";
import { Button, Input, Textarea, VStack, Heading } from "@chakra-ui/react";
import { useNavigate, useParams } from "react-router-dom";
import { createNotice, editNotice, noticeDetail } from "../../api";

export default function NoticeFormPage() {
  const navigate = useNavigate();
  const { id } = useParams();
  const isEdit = !!id;

  const [form, setForm] = useState({
    title: "",
    content: "",
    targetType: "ALL",
    pinned: false,
    publishNow: true,
  });

  const fetchDetail = async () => {
    const res = await noticeDetail({ id });
    setForm(res);
  };

  useEffect(() => {
    if (isEdit) fetchDetail();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const handleSubmit = async () => {
    if (!form.title || !form.content) {
      alert("제목과 내용을 입력해주세요");
      return;
    }
    try {
      if (isEdit) {
        await editNotice({ id, body: form });
      } else {
        await createNotice({ body: form });
      }
      navigate("/notices");
    } catch (e) {
      alert("저장 실패");
    }
  };

  return (
    <VStack align="stretch" spacing="12px">
      <Heading size="md">{isEdit ? "공지 수정" : "공지 등록"}</Heading>

      <Input
        bg="white"
        placeholder="제목"
        value={form.title}
        onChange={(e) => setForm({ ...form, title: e.target.value })}
      />

      <Textarea
        bg="white"
        placeholder="내용"
        value={form.content}
        onChange={(e) => setForm({ ...form, content: e.target.value })}
        minH="300px"
      />

      <Button alignSelf="end" colorScheme="blue" onClick={handleSubmit}>
        등록
      </Button>
    </VStack>
  );
}
